var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy - Outline - 40x40px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3415 29.2683V8.4724V2.92683H15.7317V29.2683H31.3415ZM33.2927 32.1951H26.4634V39.0244C26.4634 39.5632 26.0266 40 25.4878 40H5.97561C5.4368 40 5 39.5632 5 39.0244V8.78049C5 8.24167 5.4368 7.80488 5.97561 7.80488H12.8049V0.975609C12.8049 0.436794 13.2417 0 13.7805 0H33.2927C33.8315 0 34.2683 0.436795 34.2683 0.97561V8.4724V31.2195C34.2683 31.7583 33.8315 32.1951 33.2927 32.1951ZM12.8049 10.7317H7.92683V37.0732H23.5366V32.1951H13.7805C13.2417 32.1951 12.8049 31.7583 12.8049 31.2195V10.7317Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Copy.cc14418b7c5e6cea25a9ecb5398c93ae.svg";